import { render } from "./SendFile.vue?vue&type=template&id=b73b1e3c&ts=true"
import script from "./SendFile.vue?vue&type=script&lang=ts"
export * from "./SendFile.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__